import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { productLabel } from './outputPresentationModel';
const metadata = /(^id$|_id$|_ids$|Id$|Ids$|^tenant|_by$|By$|^deleted_at$|^superseded_at$|^revision_id$|^source_version$)/;
function decode(value) {
    if (typeof value !== 'string' || !/^[[{]/.test(value.trim())) return value;
    try {
        return JSON.parse(value);
    } catch  {
        return value;
    }
}
function Content({ value }) {
    const decoded = decode(value);
    if (decoded === null || decoded === undefined || decoded === '') return /*#__PURE__*/ _jsx("span", {
        children: "Not recorded"
    });
    if (typeof decoded === 'boolean') return /*#__PURE__*/ _jsx("span", {
        children: decoded ? 'Yes' : 'No'
    });
    if (Array.isArray(decoded)) return decoded.length ? /*#__PURE__*/ _jsx("ul", {
        className: "space-y-2 border-l pl-3",
        children: decoded.map((item, index)=>/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx(Content, {
                    value: item
                })
            }, index))
    }) : /*#__PURE__*/ _jsx("span", {
        children: "None recorded"
    });
    if (typeof decoded === 'object') {
        const entries = Object.entries(decoded);
        const provenance = entries.filter(([key])=>metadata.test(key));
        return /*#__PURE__*/ _jsxs("div", {
            className: "space-y-2",
            children: [
                /*#__PURE__*/ _jsx("dl", {
                    className: "space-y-2",
                    children: entries.filter(([key])=>!metadata.test(key)).map(([key, item])=>/*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("dt", {
                                    className: "font-medium",
                                    children: productLabel(key)
                                }),
                                /*#__PURE__*/ _jsx("dd", {
                                    className: "whitespace-pre-wrap break-words",
                                    children: /*#__PURE__*/ _jsx(Content, {
                                        value: item
                                    })
                                })
                            ]
                        }, key))
                }),
                provenance.length > 0 && /*#__PURE__*/ _jsxs("details", {
                    children: [
                        /*#__PURE__*/ _jsx("summary", {
                            className: "cursor-pointer text-muted-foreground",
                            children: "Record details"
                        }),
                        /*#__PURE__*/ _jsx("dl", {
                            children: provenance.map(([key, item])=>/*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("dt", {
                                            children: productLabel(key)
                                        }),
                                        /*#__PURE__*/ _jsx("dd", {
                                            className: "break-all",
                                            children: /*#__PURE__*/ _jsx(Content, {
                                                value: item
                                            })
                                        })
                                    ]
                                }, key))
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("span", {
        className: "whitespace-pre-wrap break-words",
        children: String(decoded)
    });
}
export function SourceContent({ content }) {
    let parsed;
    try {
        parsed = JSON.parse(content);
    } catch  {
        return /*#__PURE__*/ _jsx("p", {
            role: "alert",
            children: "Source details could not be read. Open the owning source to inspect it."
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "text-sm",
        children: /*#__PURE__*/ _jsx(Content, {
            value: parsed
        })
    });
}
